import { render, staticRenderFns } from "./DepositDialog.vue?vue&type=template&id=5b0d0ffa&scoped=true"
import script from "./DepositDialog.vue?vue&type=script&lang=js"
export * from "./DepositDialog.vue?vue&type=script&lang=js"
import style0 from "./DepositDialog.vue?vue&type=style&index=0&id=5b0d0ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d0ffa",
  null
  
)

export default component.exports